import { Text, VFlow } from 'bold-ui'
import React, { Fragment } from 'react'
import { formatDate } from 'util/date/formatDate'
import { humanizeAge } from 'util/date/humanize-age'

interface IdadeCidadaoGruposProps {
  readonly dataNascimento?: string
  readonly messageNoInfo?: string
}

export function IdadeCidadaoGrupos(props: IdadeCidadaoGruposProps) {
  const { dataNascimento, messageNoInfo = '-' } = props

  if (!dataNascimento) return <Fragment>{messageNoInfo}</Fragment>

  return (
    <VFlow vSpacing={0}>
      <Text>{formatDate(dataNascimento)}</Text>
      <Text>{humanizeAge(dataNascimento)}</Text>
    </VFlow>
  )
}
